// src/app/axios/bareClient.ts
import axios from "axios";
export const bareClient = axios.create({
  baseURL: "/api/v1",
});